import React from 'react';
import Button from 'react-bootstrap/Button';
import Modal, { ModalProps } from 'react-bootstrap/Modal';

export const ConfirmModal: React.FC<ModalProps> = ({ show, onValidate, onAbort, title, body, isNotif = false }) => {
    return (
        <Modal
            show={show}
            onHide={onAbort}
            backdrop="static"
            keyboard={false}
            centered
        >
            {title && <Modal.Header closeButton>
                <Modal.Title>{title}</Modal.Title>
            </Modal.Header>}
            <Modal.Body>
                {body}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="light" onClick={onAbort}>
                    Annuler
                </Button>
                {isNotif ? (<Button variant="primary" onClick={onValidate}>Confirmer</Button>) : (<Button variant="danger" onClick={onValidate}>Supprimer</Button>)}
            </Modal.Footer>
        </Modal>
    );
};